module.exports = __webpack_public_path__ + "static/media/tag.39a7abcf.svg";